import * as firebase from "firebase";

export default {
    state: {
        myWorkData: undefined,
        myWorkLoading: false
    },
    getters: {
        getMyWork(state) {
            return state.myWorkData;
        },
        myWorkLoading(state) {
            return state.myWorkLoading
        }
    },
    mutations: {
        setMyWorkData(state, payload) {
            state.myWorkData = payload;
        },
        setMyWorkLoading(state, payload) {
            state.myWorkLoading = payload;
        }
    },
    actions: {
        fetchMyWorkFromDatabase({commit}) {
            commit("setMyWorkLoading", true);
            firebase.database().ref("/myWork/").once("value")
                .then((data) => {
                    const myWorkData = data.val();
                    commit("setMyWorkData", myWorkData);
                    commit("setMyWorkLoading", false);
                })
                .catch((error) => {
                    commit("setErrorMessage", error.message);
                    commit("setMyWorkLoading", false);
                });
        },
        handleDownloadMyWork({commit}, payload) {
            commit("setLoading", true);
            firebase.firestore().collection("workDownloads").doc()
                .set(payload)
                .then(() => {
                    window.open(payload.work.link, "_blank");
                    commit("setLoading", false);
                })
                .catch((error) => {
                    commit("setErrorMessage", error.message);
                    commit("setLoading", false);
                })
        }
    }
}